export default __webpack_public_path__ + "static/media/alejandro-loguercio-teaching-bio.3d589a61.jpg";